import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService, TreeNode } from "primeng/api";
import { MenuService } from "../../../../master/services";

@Component({
	selector: "caass-manage-reports",
	templateUrl: "./manage-reports.component.html",
	styleUrls: ["./manage-reports.component.css"],
})
export class ManageReportsComponent implements OnInit {
	constructor(private menuService: MenuService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.LoadApplicationItems();
	}

	ngOnChanges() {
		// if(this.ReportsFromMain != undefined){
		//   // if(this.TreeItems.length != 0){
		//   //   this.UpdateReports();
		//   // }
		//   // else{
		//   //   this.LoadApplicationItems();
		//   // }
		// }

		if (this.TreeItems.length != 0) {
			this.UpdateReports();
		}

		// console.log("DisableControls");
		// console.log(this.DisableControls);
	}

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////
	@Input() ReportsFromMain: any;
	@Input() DisableControls: any = false;

	SelectedAppItem: any;

	ApplicationItems: any = [];
	TreeItems: TreeNode[] = [];

	cols = [{ field: "ApplicationItemName", header: "Name" }];

	CurrentAccess = false;

	loading: any = false;

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////
	LoadApplicationItems() {
		this.loading = true;

		//Testing
		var result = this.menuService.getApplicationItems();
		result.subscribe(
			(response) => {
				this.ApplicationItems = response;

				this.UpdateTreeData();
			},
			(error) => {}
		);
	}

	UpdateTreeData() {
		for (var i = 0; i < this.ApplicationItems.length; i++) {
			var next = this.ApplicationItems[i];

			//Get report child items
			if (String(next.ApplicationItemKey) == "Report") {
				for (var x = 0; x < this.ApplicationItems[i].Children.length; x++) {
					var nextChild = this.ApplicationItems[i].Children[x];

					var nextChildNode: TreeNode = null;
					if (nextChild.Children.length == 0) {
						nextChildNode = {
							data: {
								ApplicationItemID: nextChild.ApplicationItemID,
								ApplicationItemName: nextChild.ApplicationItemName,
								Access: false,
								ReportID: nextChild.ReportID,
							},
						};
					} else {
						var lstSubChildren: TreeNode[] = [];

						for (var z = 0; z < nextChild.Children.length; z++) {
							var nextSubChild = nextChild.Children[z];

							var nextSubChildNode: TreeNode = {
								data: {
									ApplicationItemID: nextSubChild.ApplicationItemID,
									ApplicationItemName: nextSubChild.ApplicationItemName,
									Access: false,
									ReportID: nextSubChild.ReportID,
								},
							};

							lstSubChildren = [...lstSubChildren, nextSubChildNode];
						}

						nextChildNode = {
							data: {
								ApplicationItemID: nextChild.ApplicationItemID,
								ApplicationItemName: nextChild.ApplicationItemName,
								Access: false,
								ReportID: nextChild.ReportID,
							},
							children: lstSubChildren,
						};
					}

					this.TreeItems = [...this.TreeItems, nextChildNode];
				}
			}
		}

		this.UpdateReports();
	}

	UpdateReports() {
		if (this.ReportsFromMain != undefined) {
			for (var i = 0; i < this.ReportsFromMain.length; i++) {
				var nextReport = this.ReportsFromMain[i];

				for (var x = 0; x < this.TreeItems.length; x++) {
					var nextNode = this.TreeItems[x];

					// if(nextReport.ReportGroupDesc == nextNode.data.ApplicationItemName){
					if (nextNode.children != undefined) {
						for (var z = 0; z < nextNode.children.length; z++) {
							var nextChild = nextNode.children[z];

							if (
								Number(nextReport.ReportID) == Number(nextChild.data.ReportID) ||
								//Names the same and no report ID
								(String(nextReport.ReportDisplayName).toLowerCase() == String(nextChild.data.ApplicationItemName).toLowerCase() &&
									nextReport.ReportID == undefined)
							) {
								nextChild.data.Access = true;
								break;
							}

							//Weird behavior because District User's and District Level Roles get District level reports built in
							//Includes some w/ similar names to the ones in Action

							//Special cases
							// if((Number(nextReport.ReportID == 330) || Number(nextReport.ReportID == 331)) &&
							//   (Number(nextChild.data.ReportID) == 330 ||  Number(nextChild.data.ReportID) == 331)){
							//   nextChild.data.Access = true;
							//   break;
							// }
						}
					}
				}
			}
		}

		// //Make parent accessible if all children are checked
		// for(var i = 0; i < this.TreeItems.length; i++){
		//   var nextParent = this.TreeItems[i];
		//   var allChecked = true;

		//   if(nextParent.children != undefined){
		//     for(var x = 0; x < nextParent.children.length; x++){
		//       var nextChild = nextParent.children[x];

		//       //If any children are not accessible then the whole category is not accessible
		//       if(nextChild.data.Access == false){
		//         allChecked = false;
		//       }
		//     }
		//   }
		//   nextParent.data.Access = allChecked;
		// }

		//Make parent accessible if any children are checked
		for (var i = 0; i < this.TreeItems.length; i++) {
			var nextParent = this.TreeItems[i];
			var anyChecked = false;

			if (nextParent.children != undefined) {
				for (var x = 0; x < nextParent.children.length; x++) {
					var nextChild = nextParent.children[x];

					//If any children are accessible then the whole category is accessible
					if (nextChild.data.Access == true) {
						anyChecked = true;
					}
				}
			}
			nextParent.data.Access = anyChecked;
		}

		this.loading = false;
	}
	///////////////////////////////////////////

	///////////////////////////////////////////
	// Events
	///////////////////////////////////////////

	nodeSelect(val) {
		this.SelectedAppItem = val.node;

		this.UpdateCheck();
	}
	nodeUnselect(val) {
		this.SelectedAppItem = null;
	}

	UpdateParent(parent) {
		if (parent != undefined) {
			//Set values to true if at least one child's value is true
			var Access = false;

			for (var i = 0; i < parent.children.length; i++) {
				var next = parent.children[i];

				if (next.data.Access == true) {
					Access = true;
					break;
				}
			}

			//Only update if parent's data is false?
			// if(parent.data.Access == false){
			//   parent.data.Access = Access;
			// }

			parent.data.Access = Access;

			if (parent.parent != undefined) {
				this.UpdateParent(parent.parent);
			}
		}
	}

	UpdateCheck() {
		if (this.SelectedAppItem != null && this.SelectedAppItem != undefined) {
			this.CurrentAccess = this.SelectedAppItem.data.Access;
		} else {
			this.CurrentAccess = false;
		}

		if (this.SelectedAppItem != undefined) {
			if (this.SelectedAppItem.parent != undefined) {
				this.UpdateParent(this.SelectedAppItem.parent);
			}
		}
	}

	DisableCheck() {
		this.UpdateCheck();
		return this.DisableControls == true || this.SelectedAppItem == null || this.SelectedAppItem == undefined;
	}

	onAccessChange(val) {
		//Ask if user wants to apply changes to children
		if (this.SelectedAppItem.children != undefined) {
			var confirmMsg = "Do you want to enable access rights on all child items of the " + this.SelectedAppItem.data.ApplicationItemName + " application?";

			this.confirmationService.confirm({
				key: "report",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: confirmMsg,
				header: "Access Rights",
				icon: "fa",
				accept: () => {
					this.UpdateAccessRights(val);
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateAccessRights(val);
		}
	}

	UpdateAccessRights(val) {
		this.SelectedAppItem.data.Access = val;

		if (this.SelectedAppItem.children != undefined) {
			for (var i = 0; i < this.SelectedAppItem.children.length; i++) {
				var child = this.SelectedAppItem.children[i];

				child.data.Access = val;

				if (child.children != undefined) {
					for (var z = 0; z < child.children.length; z++) {
						var subChild = child.children[z];
						subChild.data.Access = val;
					}
				}
			}
		}

		this.UpdateCheck();
	}

	///////////////////////////////////////////
}
